<template>
  <div class="popWin" id="modalPay3DSAuth" v-show="ShowModel">
    <div class="popWinCompenent">
      <div class="popWinBody">
        <div class="popWinHeader">
          <h4>3D Secure Notice</h4>
        </div>
        <div class="popWinContent">
          <div class="wordsCol">
            <p>Sorry, this payment has been rejected by your bank.</p>
          </div>
        </div>
      </div>
      <div class="popWinButtonCol">
        <button class="btn btn-yellow" type="button" @click="next">
          Return to checkout
        </button>
        <button class="btn btn-transparent" id="closeBtn" type="button">CANCEL</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pay3DSAuth",
  data() {
    return {
		ShowModel: false,
    };
  },
  methods: {
    next() {
		this.$router.push({
			path: "/orderDetail"
		});
    },
  },
};
</script>
<style>
	.popWinContent {
		padding-top: 40px;
		text-align: center;
	}

	.popWinContent * {
		text-align: center;
		line-height: 2;
	}

	#closeBtn {
		display: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/modal/Pay3DSAuth.vue